<template>
  <Card
    :title="'Term of Service Management'"
  >
    <template v-slot:button>
      <Button  @clicked="save" variant="primary" :label="labelSaveButton" />
    </template>
    <template v-slot:body>
      <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" @ready="onReady" :disabled="isLoading"  ></ckeditor>
    </template>
  </Card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import CKEditor from '@ckeditor/ckeditor5-vue2';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import Card from '@/components/Layout/Card.vue';
import { Button } from '@/components/Layout/Form';

export default {
  name: 'TncManagement',
  data: () => ({
    isTncHasBeenUpdated: false,
    editor: DecoupledEditor,
    editorData: '',
    editorConfig: {
    },
  }),
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestContentTermOfCondition();
    this.editorData = this.contentTermsOfCondition;
  },
  computed: {
    ...mapGetters('TermsOfConditionModule', ['contentTermsOfCondition']),
    ...mapGetters('NotificationModule', ['isLoading']),
    labelSaveButton() {
      return !this.isLoading ? 'Save' : '';
    },
  },
  methods: {
    ...mapActions('TermsOfConditionModule', ['requestContentTermOfCondition', 'updateContentTermOfCondition']),
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement(),
      );
    },
    async save() {
      try {
        await this.updateContentTermOfCondition(this.editorData);
        this.isTncHasBeenUpdated = true;
        this.$swal('Success', 'You successfully update term of service', 'success');
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    toggleToast() {
      this.isTncHasBeenUpdated = false;
    },
  },
  components: {
    ckeditor: CKEditor.component,
    Card, Button
  },
};
</script>
<style>
.ck-content { height:300px; }

</style>



// WEBPACK FOOTER //
// src/views/TncManagement.vue